"use client";

import { Suspense } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { safeNextPath } from "@/lib/auth/safe-next";
import { BrandIcon } from "@/components/brand/icons";
import { AuthJourney, ZitadelSignInButton } from "@/components/auth";

function LoginForm() {
  const searchParams = useSearchParams();
  const reason = searchParams.get("reason");
  // Honour a same-origin ?next (e.g. /invite/accept bounces here when signed
  // out). safeNextPath rejects protocol-relative + backslash off-site targets —
  // critical here because this is a client router.push with no origin prefix.
  const safeNext = safeNextPath(searchParams.get("next"));

  return (
    <AuthJourney
      outcome="form"
      title="Sign in"
      subtitle="Welcome back. Your floorplans are waiting."
      banner={
        reason === "inactivity" ? (
          <div
            className="tdo-banner"
            role="status"
            style={{ marginBottom: "var(--tdo-sp-5)" }}
          >
            <BrandIcon name="clock" size={16} />
            <span className="tdo-p3" style={{ flex: 1 }}>
              You were signed out after an hour of inactivity. Your work was
              saved.
              {safeNext ? " Sign in to return to where you were." : ""}
            </span>
          </div>
        ) : undefined
      }
      footer={
        <Link className="tdo-link" href="/">
          Back to home
        </Link>
      }
    >
      <ZitadelSignInButton next={safeNext} />
    </AuthJourney>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={null}>
      <LoginForm />
    </Suspense>
  );
}
